const auth = {
    'auth.register': 'Register',

    'auth.login': 'Login',
    'auth.login_as': 'Login as',
    'auth.login_as.reseller': 'Login as reseller',
    'auth.login_as.client': 'Log is as customer',
    'auth.login.error': 'Wrong combination of e-mail address and password!',
    'auth.login.sub.error': 'Make sure you activate your account first. there is an email send to the email we know',

    'auth.logout': 'Log out',

    'auth.forgot_password': 'Forgot password',
    'auth.forgot_password.explanation': 'Enter your e-mail address below. We will send you an e-mail with a link with which you can set a new password.',
    'auth.forgot_password.ok': 'Password reset email has been sent successfully!',
    'auth.forgot_password.error': 'Email address is not recognized.',

    'auth.reset_password': 'Reset password',
    'auth.reset_password.ok': 'Your password has been changed successfully!',
    'auth.reset_password.error': 'Something went wrong with changing your password.',

    'auth.send_password': 'Send password',

    'auth.back_to_login': 'Return to login',

    'auth.my_account': 'My account',
};

export default auth;
